var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.5.82C17.675.82 22.68 5.825 22.68 12S17.675 23.18 11.5 23.18.32 18.175.32 12 5.325.82 11.5.82m0 1.355c-5.426 0-9.825 4.399-9.825 9.825s4.399 9.825 9.825 9.825 9.825-4.399 9.825-9.825-4.399-9.825-9.825-9.825m-.26 2.805c.424 0 .769.337.78.756v6.524h4.666c.439 0 .794.35.794.78a.787.787 0 0 1-.773.78h-5.453a.787.787 0 0 1-.794-.78q0-.136.045-.259a.8.8 0 0 1-.045-.237V5.757c0-.43.35-.777.78-.777"
  })));
};
export default SvgClock;